import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { usePageMeta } from './usePageMeta'
import HeaderSection from './HeaderSection'
import FooterSection from './FooterSection'
import HeadSpace from '../utils/HeadSpace'
// import { Header } from "./Header";

interface LayoutProps {
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Update page meta tags
  usePageMeta()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <HeaderSection />
      <HeadSpace />

      {/* Main Content */}
      <main className="flex-1 overflow-x-hidden">{children || <Outlet />}</main>

      {/* Footer */}
      <FooterSection />
    </div>
  )
}

export default Layout
